// extracted by mini-css-extract-plugin
export default {"attendeeExpandableSection":"P7L63Hx1rm","expandButton":"J_igtjVjpk","expandButtonText":"E23nHlnzCm","expandButtonIcon":"OE3d3XA3ad"};